export default __webpack_public_path__ + "static/B0017-ccc21334889b132bae656c0dde26cfca.png";